import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateUtilityAccountDetailMutation,
  Flex_UpdateUtilityAccountDetailMutationVariables,
} from '~/typings/graphql';
import { UPDATE_UTILITY_ACCOUNT_DETAIL } from './update-utility-account-detail.queries';

export interface UpdateUtilityAccountDetailParams {
  utilityAccountId: number;
  requiresAffirmativeConsent: boolean;
}

export type UpdateUtilityAccountDetailResponse = {
  utilityAccountDetailId: number;
};

export const updateUtilityAccountDetail = async (
  params: UpdateUtilityAccountDetailParams,
): Promise<UpdateUtilityAccountDetailResponse> => {
  await apolloClient.mutate<
    Flex_UpdateUtilityAccountDetailMutation,
    Flex_UpdateUtilityAccountDetailMutationVariables
  >({
    mutation: UPDATE_UTILITY_ACCOUNT_DETAIL,
    variables: {
      utilityAccountId: params.utilityAccountId,
      input: {
        requiresAffirmativeConsent: params.requiresAffirmativeConsent,
      },
    },
  });

  return {
    utilityAccountDetailId: params.utilityAccountId,
  };
};
